import { __ } from '@wordpress/i18n';
import Control from './Control';
const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes, setAttributes, className }) => {
  const handleOnChangeTitle = (title) => {
    setAttributes({ title });
  };

  const handleOnChangeSubTitle = (subtitle) => {
    setAttributes({ subtitle });
  };

  return (
    <>
      <Control attributes={attributes} setAttributes={setAttributes} />

      <div className="wp-block-custom-form-block">
        <div className="wrapper">
          <RichText
            tagName="h1"
            className="has-text-align-center"
            value={attributes.title}
            placeholder={__('Titulo do formulário')}
            onChange={handleOnChangeTitle}
          />
          <RichText
            tagName="p"
            className="has-text-align-center"
            value={attributes.subtitle}
            placeholder={__('Subtítulo do formulário')}
            onChange={handleOnChangeSubTitle}
          />

          <InnerBlocks
            allowedBlocks={[
              'core/buttons',
              'core/paragraph',
              'core/spacer',
              'custom-form/text-input',
              'custom-form/checkbox'
            ]}
          />
        </div>
      </div>
    </>
  );
}
